export default __webpack_public_path__ + "static/media/583.4aa05a0f.gif";